import * as Masonry from 'masonry-layout';
import * as imagesLoaded from 'imagesloaded';

class Gallery {
  constructor() {
    this._init();
  }

  _init() {
    // Récupérer l'élément HTML du conteneur
    const grids = document.querySelectorAll('.grid');

    grids.forEach(grid => {
      // Initialiser Masonry pour chaque grille
      if (grid) {
        imagesLoaded(grid, () => {
          new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true
          });
        });
      }
    });
  }
}

export const gallery = new Gallery();
